<template>
    <div class="alert-wrapper">
        <div class="alert" :class="'alert-'+alert.type" v-for="alert in this.$root.$data.alerts">
            {{ alert.message }}
        </div>
    </div>
</template>

<script>
    export default {
        name: "Alerts",
    }
</script>

<style scoped>

</style>
